import React from 'react';
import ContentLoader from 'react-content-loader'

import { getLoaderColors } from '../../utils/theme';

import { ThemeContext } from '../../context/ThemeContext';

const Placeholder = props => {
    return (
        <ThemeContext.Consumer>
            {
                ({ theme }) => (
                    <div className="subtask-item placeholder">
                        <ContentLoader width="638" height="22" animate={!props.static} backgroundColor={getLoaderColors(theme).primary} foregroundColor={getLoaderColors(theme).secondary}>
                            <rect x="0" y="1" rx="3" ry="3" width="20" height="20" />
                            <rect x="38" y="7" rx="4" ry="4" width="440" height="8" />
                        </ContentLoader>
                    </div>
                )
            }
        </ThemeContext.Consumer>
    )
}

export default Placeholder;
